<template>
 <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
     >
      <div class="d-sm-flex align-items-center">
        <a v-if="checkPermission('GenererRedevance')"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#genererRedevanceModal"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Générer une redevance
        </a>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Exporter
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une redevance"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <!-- <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block"
          type="button"
        >
          <i class="flaticon-dots"></i>
        </button> -->
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                BUREAU
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                CATEGORIE D'ABONNE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                MODELE DE BOITE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ANNEE
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                DATE
              </th>
              <!-- <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(re , index) in redevances" :key="index" >
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.bureau ? ((re.bureau.nom.length > 20 ) ? re.bureau.nom.substring(0, 20) + '...' : re.bureau.nom ) : '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.categorieAbonne ? ((re.categorieAbonne.libelle.length > 20 ) ? re.categorieAbonne.libelle.substring(0, 20) + '...' : re.categorieAbonne.libelle ) : '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.modeleBoite ? re.modeleBoite.code+' [ '+ re.modeleBoite.libelle+' ]' : '' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ re.annee }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(re.createdAt) }}
              </td>
              <td  class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                    <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        Actions
                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                    </span>
                    <ul class="dropdown-menu">
                      <li v-if="!re.fichierGenerer">
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#"
                          @click.prevent="genrerFichier(re)" 
                          
                        >
                          <i class="flaticon-money lh-1 me-8 position-relative top-1" ></i>
                          Generer le fichier
                        </a>
                    </li>
                    <li v-else>
                        <a
                          class="dropdown-item d-flex align-items-center"
                          href="#"
                          @click.prevent="openNewWindow(re)"
                        >
                          <i class="flaticon-money lh-1 me-8 position-relative top-1" ></i>
                          Télécharger les avis
                        </a>
                    </li>
                    </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <GenererRedevanceModal @close="recharger"  />
  
  <!-- Modal de progression -->
  <div v-if="showProgressModal" class="modal d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Génération en cours</h5>
        </div>
        <div class="modal-body">
          <div class="text-center mb-3">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div class="progress mb-3" style="height: 25px;">
            <div 
              class="progress-bar progress-bar-striped progress-bar-animated" 
              role="progressbar" 
              :style="{ width: progressPercentage + '%' }"
              :aria-valuenow="progressPercentage" 
              aria-valuemin="0" 
              aria-valuemax="100"
            >
              {{ progressPercentage }}%
            </div>
          </div>
          <div class="text-center">
            <p class="mb-2 fw-medium">{{ progressMessage }}</p>
            <small class="text-muted">{{ progressDetails }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import ApiService from '@/services/ApiService';
import { Redevance } from '@/models/Redevance';
import  GenererRedevanceModal  from './GenererRedevanceModal.vue';
import { success, error, format_date, openAndPrint, getUrlApiForFiles } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { EnvoieLotDetail } from '@/models/EnvoieLotDetail';
import SocketService from '@/services/SocketService';
import Swal from 'sweetalert2';

export default defineComponent({
  name: "GenererRedevance",
  components: {
    GenererRedevanceModal,
    PaginationComponent
  },
setup: () => {

  const redevances = ref<Array<EnvoieLotDetail>>([]);

   // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const progressMessage = ref('Initialisation...');
    const progressDetails = ref('');
    const progressPercentage = ref(0);
    const showProgressModal = ref(false);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllRedevances(page_, limit_);
      } catch (error) {
        //
      }
    };
    function rechercher(){
      getAllRedevances(page.value, limit.value, searchTerm.value );
    }
    // END PAGINATE

    const recharger = () => {
      getAllRedevances();
    };

    const getAllRedevances = async (page = 1, limi = 10, searchTerm = '') => {
      ApiService.get(`/envoie/lot/details?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      .then(({ data }) => {
        const donnees = data.data.data;
        redevances.value = donnees;
         totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    function openNewWindow(data:any) {
      console.log("Ouverture du fichier de redevance:", data);
      openAndPrint(getUrlApiForFiles("Redevance",data.fichier));
    }

    const genrerFichier = async (data:any) => {
      try {
        
        // Réinitialiser les valeurs de progression
        progressPercentage.value = 0;
        progressMessage.value = 'Initialisation de la génération...';
        progressDetails.value = 'Préparation des données...';
        
        // Afficher le modal de progression avec Vue.js
        showProgressModal.value = true;
        console.log("Démarrage de la génération de la redevance pour l'ID:", data.id);

        ApiService.post(`/redevance/generer-lot-fichier`, { idEnvoieLotDetail: data.id })
        
        .then(async ({ data }) => {
          // Fermer le modal

          console.log("Réponse de l'API après la demande de génération:", data.code, data.data);

          if (data.code === 200) {

            showProgressModal.value = false;
            success("Fichier généré avec succès");
            recharger();
            console.log("oui");

          }
        })
        .catch(({ response }) => {
          // Fermer le modal en cas d'erreur
          showProgressModal.value = false;
          error(response.data.message)
        });

      } catch (err) {
        error("Une erreur s'est produite lors de la génération");
        console.log("mon erreur", err);
      }
    }
    
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }


    onMounted(() => {
      getAllRedevances();
      listenSockerForGeneration();
    });

    const listenSockerForGeneration = () => {
      console.log("Écoute des événements de génération de redevance");
      
      SocketService.on("generation_fu_progress", (data) => {
        console.log("Données reçues du serveur WebSocket:", data);
        if (data) {
          progressPercentage.value = data.percentage || 0;
          progressMessage.value = data.message || 'Traitement en cours...';
          progressDetails.value = data.details || '';
          console.log("Redevance mise à jour:", data);
          
          // Si la génération est terminée
          // if (data.completed || data.percentage >= 100) {
            // Fermer le modal avec Vue.js
            // showProgressModal.value = false;
            
            // if (data.success !== false) {
              // success("La redevance a été générée avec succès");
              // recharger(); // Recharger les données
            // } else {
            //   error(data.error || "Erreur lors de la génération");
            // }
          // }

        }
      });
    };

  return { 
    redevances,
    recharger,
    format_date,
    page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    searchTerm,
    rechercher,
    checkPermission,
    openNewWindow,
    genrerFichier,
    progressMessage,
    progressDetails,
    progressPercentage,
    showProgressModal
  };

},
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
